import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import BackgroundSection from './components/BackgroundSection';
import JobDescriptionSection from './components/JobDescriptionSection';
import IdealCandidateSection from './components/IdealCandidateSection';
import ConditionsSection from './components/ConditionsSection';
import CEOMessageSection from './components/CEOMessageSection';
import TeamSection from './components/TeamSection';
import ApplicationSection from './components/ApplicationSection';


export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://chammi.co.jp';

    const jobPosting = {
      '@context': 'https://schema.org',
      '@type': 'JobPosting',
      title: 'AIアニメ制作スタジオ マネージャー',
      description:
        'Chammi Inc.は高知県にAIアニメ制作スタジオを新設します。スタジオ立ち上げを担うマネージャーを募集しています。日本の創作文化をグローバルに展開するプロジェクトをリードしてください。',
      datePosted: '2026-04-01',
      employmentType: 'FULL_TIME',
      hiringOrganization: {
        '@type': 'Organization',
        name: 'Chammi Inc.',
        sameAs: siteUrl,
        logo: 'https://storage.readdy-site.link/project_files/777ff6c9-ee60-489f-b76a-eca20a2d3e36/921865f1-eb94-43ab-9eae-5b95ce24bd25_-2026-04-01-21.38.52.png?v=dc4243f587326e85e9668878523bfb8a',
      },
      jobLocation: {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressLocality: '高知市',
          addressRegion: '高知県',
          addressCountry: 'JP',
        },
      },
      baseSalary: {
        '@type': 'MonetaryAmount',
        currency: 'JPY',
        value: {
          '@type': 'QuantitativeValue',
          unitText: 'YEAR',
        },
      },
    };

    const organization = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Chammi Inc.',
      url: siteUrl,
      logo: 'https://storage.readdy-site.link/project_files/777ff6c9-ee60-489f-b76a-eca20a2d3e36/921865f1-eb94-43ab-9eae-5b95ce24bd25_-2026-04-01-21.38.52.png?v=dc4243f587326e85e9668878523bfb8a',
      description:
        '日本発コンテンツIPのグローバル展開を支援する会社。東京・Los Angeles・高知に拠点を持ち、AIアニメ制作スタジオを新設。',
      address: [
        {
          '@type': 'PostalAddress',
          addressLocality: '東京',
          addressCountry: 'JP',
        },
        {
          '@type': 'PostalAddress',
          addressLocality: '高知市',
          addressRegion: '高知県',
          addressCountry: 'JP',
        },
      ],
      sameAs: [siteUrl],
    };

    const webPage = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '採用情報 | Chammi Inc. — AIアニメ制作スタジオ マネージャー 高知拠点',
      description:
        'Chammi Inc.（チャンミ）は日本発コンテンツIPのグローバル展開を支援する会社です。高知県にAIアニメ制作スタジオを新設。スタジオ立ち上げを担うマネージャーを募集しています。',
      url: siteUrl,
      inLanguage: 'ja',
      publisher: {
        '@type': 'Organization',
        name: 'Chammi Inc.',
      },
    };

    const scripts = [
      { id: 'schema-jobposting', data: jobPosting },
      { id: 'schema-organization', data: organization },
      { id: 'schema-webpage', data: webPage },
    ];

    scripts.forEach(({ id, data }) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    });

    return () => {
      scripts.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <main className="bg-cream font-sans">
      <Navbar />
      <HeroSection />
      <CEOMessageSection />
      <BackgroundSection />
      <JobDescriptionSection />
      <IdealCandidateSection />
      <ConditionsSection />
      <TeamSection />
      <ApplicationSection />

      {/* Footer */}
      <footer className="bg-white border-t border-warm-border py-12">
        <div className="max-w-6xl mx-auto px-6 md:px-10 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center">
            <img
              src="https://storage.readdy-site.link/project_files/777ff6c9-ee60-489f-b76a-eca20a2d3e36/921865f1-eb94-43ab-9eae-5b95ce24bd25_-2026-04-01-21.38.52.png?v=dc4243f587326e85e9668878523bfb8a"
              alt="Chammi Inc."
              className="h-7 w-auto object-contain"
            />
          </div>
          <div className="flex items-center gap-6">
            <span className="font-sans text-warm-muted text-xs">東京 · Los Angeles · 高知（新設）</span>
            <span className="font-sans text-warm-muted text-xs">
              © {new Date().getFullYear()} Chammi Inc. All rights reserved.
            </span>
          </div>
        </div>
      </footer>
    </main>
  );
}
